import React, { useEffect, useState } from "react";
import Insufficiency from "./hr-pending-action/Insufficiency";
import ExtraCost from "./hr-pending-action/ExtraCost";
import Footer from "../../../core/common/Footer";
import StoppedCases from "./StoppedCases";
import useApi from "../../../core/customhook/useApi";
import webservice_url from "../../../core/webservice/Webservice_url";
import { PageLoader } from "../../../core/common/loader/PageLoader";
import {
  ExclamationCircleOutlined,
  DollarCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";
export const statusColors: Record<string, string> = {
  Pending: "bg-warning",
  Completed: "bg-soft-success",
  "In Progress": "bg-soft-secondary",
};

// Strict type
type TabLabel =
  | "Insufficiency Checks"
  | "Additional Cost Approval"
  // | "Expired Insufficiencies"
  | "Stopped Checks";

type TabItem = {
  status_id: string;
  label: TabLabel;
  count: number;
};

// FIX: Store COMPONENT, not JSX
const componentMap: Record<TabLabel, React.ComponentType<any>> = {
  "Insufficiency Checks": Insufficiency,
  "Additional Cost Approval": ExtraCost,
  // "Expired Insufficiencies": InsuffExpired,
  "Stopped Checks": StoppedCases,
};

const iconMap: Record<TabLabel, React.ReactNode> = {
  "Insufficiency Checks": <ExclamationCircleOutlined />,
  "Additional Cost Approval": <DollarCircleOutlined />,
  "Stopped Checks": <StopOutlined />,
};

const ACTIVE_TAB_KEY = "active-hr-action-tab";

const HrPendingAction = () => {
  // Restore from localStorage directly in initial state
  const [activeTab, setActiveTab] = useState<string>(() => {
    try {
      return localStorage.getItem(ACTIVE_TAB_KEY) || "";
    } catch {
      return "";
    }
  });

  // API
  const { data: tabCount, loading } = useApi(
    webservice_url.fetch_hr_pending_action_count,
    {
      method: "GET",
      autoCall: true,
    },
  );

  // Build tabs with Component reference
  const dynamicTabs =
    (tabCount?.data as TabItem[] | undefined)?.map((item) => ({
      id: item?.label,
      status_id: item?.status_id ?? "",
      label: item?.label,
      count: item?.count,
      Component: componentMap[item?.label],
    })) ?? [];

  // Set default tab (agar stored tab valid nahi hai ya empty hai to pehla tab)
  useEffect(() => {
    if (dynamicTabs.length === 0) return;
    const exists = dynamicTabs.some((tab) => tab?.label === activeTab);

    if (!exists) {
      setActiveTab(dynamicTabs[0]?.label);
    }
  }, [dynamicTabs, activeTab]);

  const activeTabData = dynamicTabs?.find((tab) => tab?.label === activeTab);
  const ActiveComponent = activeTabData?.Component;

  const handleTabClick = (label: string) => {
    setActiveTab(label);
    try {
      localStorage.setItem(ACTIVE_TAB_KEY, label);
    } catch (err) {
      console.error("Failed to save active tab to localStorage:", err);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {loading ? (
          <PageLoader />
        ) : (
          <>
            {/* Tabs */}
            {/* <ul className="invite-tabs">
              {dynamicTabs.map((tab) => (
                <li key={tab.id}>
                  <button
                    type="button"
                    className={`invite-btn ${
                      activeTab === tab.label ? "active" : ""
                    }`}
                    onClick={() => handleTabClick(tab.label)}
                  >
                    <span className="d-block">{tab.label}</span>
                    {typeof tab.count === "number" && (
                      <span className="d-block fw-semibold">{tab.count}</span>
                    )}
                  </button>
                </li>
              ))}
            </ul> */}

            <ul className="invite-tabs">
              {dynamicTabs.map((tab) => (
                <li key={tab.id}>
                  <button
                    type="button"
                    className={`invite-btn ${
                      activeTab === tab.label ? "active" : ""
                    }`}
                    onClick={() => handleTabClick(tab.label)}
                  >
                    <span className="d-flex align-items-center justify-content-center gap-2">
                      {iconMap[tab.label as TabLabel]}
                      <span>{tab.label}</span>
                    </span>

                    {typeof tab.count === "number" && (
                      <span className="d-block fw-semibold">{tab.count}</span>
                    )}
                  </button>
                </li>
              ))}
            </ul>

            {/* Tab Content */}
            <div className="mt-4 pt-2">
              {ActiveComponent && (
                <ActiveComponent status_id={activeTabData?.status_id} />
              )}
            </div>
          </>
        )}
      </div>

      {/* ---- Footer ---- */}
      <Footer />
    </div>
  );
};

export default HrPendingAction;

// import React, { useEffect, useState } from "react";
// import Insufficiency from "./hr-pending-action/Insufficiency";
// import ExtraCost from "./hr-pending-action/ExtraCost";
// import TabItems from "../../../core/common/TabItems";
// import Footer from "../../../core/common/Footer";
// import StoppedCases from "./StoppedCases";
// import useApi from "../../../core/customhook/useApi";
// import webservice_url from "../../../core/webservice/Webservice_url";
// import { PageLoader } from "../../../core/common/loader/PageLoader";

// export const statusColors: Record<string, string> = {
//   Pending: "bg-warning",
//   Completed: "bg-soft-success",
//   "In Progress": "bg-soft-secondary",
// };

// // Strict type
// type TabLabel =
//   | "Insufficiency Checks"
//   | "Additional Cost Approval"
//   // | "Expired Insufficiencies"
//   | "Stopped Checks";

// type TabItem = {
//   status_id: string;
//   label: TabLabel;
//   count: number;
// };

// // FIX: Store COMPONENT, not JSX
// const componentMap: Record<TabLabel, React.ComponentType<any>> = {
//   "Insufficiency Checks": Insufficiency,
//   "Additional Cost Approval": ExtraCost,
//   // "Expired Insufficiencies": InsuffExpired,
//   "Stopped Checks": StoppedCases,
// };

// const HrPendingAction = () => {
//   const [activeTab, setActiveTab] = useState<string>("");

//   // API
//   const { data: tabCount, loading } = useApi(
//     webservice_url.fetch_hr_pending_action_count,
//     {
//       method: "GET",
//       autoCall: true,
//     },
//   );

//   //  Build tabs with Component reference
//   const dynamicTabs =
//     (tabCount?.data as TabItem[] | undefined)?.map((item) => ({
//       id: item?.label,
//       status_id: item?.status_id ?? "",
//       label: item?.label,
//       count: item?.count,
//       Component: componentMap[item?.label], //  correct
//     })) ?? [];

//   const activeTabData = dynamicTabs?.find((tab) => tab?.label === activeTab);
//   const ActiveComponent = activeTabData?.Component;

//   //  Set default tab
//   useEffect(() => {
//     if (dynamicTabs.length === 0) return;
//     const exists = dynamicTabs.some((tab) => tab?.label === activeTab);

//     if (!exists) {
//       setActiveTab(dynamicTabs[0]?.id);
//     }
//   }, [dynamicTabs, activeTab]);

//   //  Restore from localStorage
//   useEffect(() => {
//     const storedTab = localStorage.getItem("active-hr-action-tab");
//     if (storedTab) {
//       setActiveTab(storedTab);
//     }
//   }, []);

//   return (
//     <div className="page-wrapper">
//       <div className="content">
//         {loading ? (
//           <PageLoader />
//         ) : (
//           <>
//             {/* Tabs */}
//             <TabItems
//               tabList={dynamicTabs}
//               activeTab={activeTab}
//               handleClick={(d) => {
//                 setActiveTab(d?.id);
//                 localStorage.setItem("active-hr-action-tab", d?.id);
//               }}
//             />
//             {/* Tab Content */}
//             <div className="mt-4 pt-2">
//               {ActiveComponent && (
//                 <ActiveComponent status_id={activeTabData?.status_id} />
//               )}
//             </div>
//           </>
//         )}
//       </div>

//       {/* ---- Footer ---- */}
//       <Footer />
//     </div>
//   );
// };

// export default HrPendingAction;

// ---- FOR tab in -> track-case-program -----

// export const HrPendingStats = [
//   {
//     id: "form_approval",
//     label: "Form Approval",
//     count: dummyData_hrApproval?.length || 0,
//     component: <FormApproval />,
//   },
// {
//   id: "previous_employment_pending",
//   label: "Employment Verification Pending",
//   // label: "Previous Employment Pending",
//   count: 0,
//   component: <PreviousEmploymentPending />,
// },
// {
//   id: "insufficiency",
//   label: "Insufficiency Cases",
//   // label: "Insufficiency",
//   count: dummyData_Insufficiency?.length || 0,
//   component: <Insufficiency />,
// },
// {
//   id: "extra_cost",
//   label: "Additional Cost Approval",
//   // label: "Extra Cost",
//   count: dummyData_ExtraCost?.length || 0,
//   component: <ExtraCost />,
// },
// {
//   id: "client_review",
//   // label: "",
//   label: "Client Review",
//   count: 0,
//   component: <ClientReview />,
// },
// {
//   id: "post_bgv_hold",
//   label: "Post Verification Hold",
//   // label: "Post BGV Hold",
//   count: 0,
//   component: <PostHold />,
// },
//   {
//     id: "insuff_expired",
//     label: "Expired Insufficiencies",
//     // label: "Insuff Expired",
//     count: dummyData_expiredInsufficiency?.length,
//     component: <InsuffExpired />,
//   },
// ];
<>
  {/* Guide Container */}
  {/* <>
        <div className="text-end">
          <Button
            className="border-secodary"
            onClick={() => setShowGuide((prev) => !prev)}
          >
            <i className="ti ti-info-circle-filled fs-16"></i>
            <div className="pb-1 ">Guide</div>
          </Button>
        </div>

        <GuideContentArea
          maxHeight={"180px"}
          showGuide={showGuide}
          handleClick={() => setShowGuide(false)}
          title={"Hr Pending Action"}
          content={
            <div>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis
              fugiat veritatis magnam iste odio sunt vitae nobis delectus
              reprehenderit id. Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Doloribus dolorum totam reprehenderit soluta
              ullam saepe quo et rem vitae quidem.
            </div>
          }
        />
      </> */}

  {/* Summary/Stat Tab */}
  {/* <div className="mt- 4 px-2 pt-3 pb-1 py3 bg-subtle rounded-3 shadow-sm bg-white">
            <div
              style={{
                overflowX: "auto",
                overflowY: "hidden",
                scrollbarWidth: "thin",
                scrollBehavior: "smooth",
                // scrollbarWidth: "none",
              }}
            >
              <div
                className="d-flex flex-nowrap gap-2 pb-0 px-1 mb-2"
                style={{ width: "max-content", minWidth: "100%" }}
              >
                {HrPendingStats?.map((itm, idx) => (
                  <div
                    key={itm.value}
                    className={`flex-grow-1 text-center `}
                    style={{ minWidth: "120px" }}
                  >
                    <button
                      type="button"
                      className={`btn border w-100 p-3 ${itm.value == activeTab ? "btn-primary text-white" : ""}`}
                      onClick={() => {
                        setActiveTab(itm.value);
                        localStorage.setItem("active-hr-action-tab", itm.value);
                      }}
                    >
                      <p className="fw-bold mb-1">{itm.label}</p>
                      <span>{itm.count}</span>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div> */}

  {/* Tab Content */}
  {/* <div className="mt-4">{activeComponent}</div> */}
</>;
